import request from '@services/lib/request';

export interface ISelf {
  avatar_url: string;
  id: number;
  nickname: string;
  sex: number;
  small_avatar_url: string;
  subscribed: boolean;
  token: string;
}

export class AccountModel {
  public static async fetchSelf(): Promise<ISelf> {
    const self = await request.$get<ISelf>('/api/account/self');
    return self;
  }
}



// WEBPACK FOOTER //
// ./src/models/account.ts